<template>
  <div class="distribution-multidiagram">
    <svg :width="svgWidth" :height="svgHeight">
      <g v-for="(layer, k) in layersChunks" :key="layer.id">
        <!-- <rect v-for="(chunk, i) in layer.chunks" :key="chunk.num"
        :width="`${getWidth(layer)}%`" 
        :x="`${getXposition(layer, k, i)}%`"
        :y="`${50}px`"
        :height="`${50}px`" 
        :data-count="chunk.count"
        :data-num="chunk.num"
        :data-min="chunk.min"
        :data-max="chunk.max"
        :fill="'rgba(255,0,0,0.5)'" stroke-width="0" /> -->
        <g v-for="(chunk, i) in layer.chunks" :key="chunk.num">
          <rect
            v-if="getHeight(layer, chunk.count)"
            :width="`${getWidth(layer)}%`"
            :x="`${getXposition(layer, k, i)}%`"
            :y="`${getYposition(layer, chunk.count)}%`"
            :height="`${getHeight(layer, chunk.count)}%`"
            :data-count="chunk.count"
            :data-num="chunk.num"
            :data-min="chunk.min"
            :data-max="chunk.max"
            :fill="getFill(layer, chunk.num)"
            stroke-width="0"
          />
        </g>
        <rect
          :width="`${getOverflowWidth()}%`"
          height="100%"
          :fill="getOverflowColor"
          :x="`${getOverflowX()}%`"
        />
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  props: ["slider", "max", "min", "layersChunks", "range-type", "point"],
  data() {
    return {
      svgHeight: 80,
      svgWidth: 720
    };
  },
  computed: {
    sliderWidth() {
      return this.max - this.min;
    },
    getOverflowColor() {
      return this.$store.state.theme === "dark-theme"
        ? "rgba(238, 238, 238, 0.05)"
        : "rgba(0, 0, 0, 0.05)";
    },
    getOtherColor() {
      return this.$store.state.theme === "dark-theme" ? "#1d1e27" : "#c1c1c4";
    }
  },
  methods: {
    getWidth(layer) {
      return (
        (this.svgWidth / (layer.chunks.length * 2 - 1) / this.svgWidth) * 100
      );
    },
    getXposition(layer, layerIndex, index) {
      if (index === 0) return 0;
      const width = this.getWidth(layer);
      let offset = width * layerIndex;
      if (index === layer.chunks.length - 1)
        offset = offset - width * (this.layersChunks.length - 1);
      else offset = offset - (width * this.layersChunks.length) / 2;
      return width * 2 * index + offset;
    },
    getYposition(layer, count) {
      const height = (count / layer.allCount) * this.svgHeight * 3;
      return ((this.svgHeight - height) / this.svgHeight) * 100;
    },
    getHeight(layer, count) {
      return (count / layer.allCount) * 300;
    },
    getFill(layer, num) {
      if (this.rangeType === "interval") {
        const percent = (num / layer.chunks.length) * 100;
        const delta = this.getWidth(layer) / 2;
        const minSliderPercent =
          ((this.slider[0] - this.min) / (this.max - this.min)) * 100 + delta;
        const maxSliderPercent =
          ((this.slider[1] - this.min) / (this.max - this.min)) * 100 + delta;

        return percent >= minSliderPercent && percent <= maxSliderPercent
          ? layer.color
          : this.getOtherColor;
      } else {
        return layer.color;
      }
    },
    getOverflowWidth() {
      if (this.rangeType === "point") return 1;
      else
        return (
          ((this.slider[1] - this.slider[0]) / (this.max - this.min)) * 100
        );
    },
    getOverflowX() {
      if (this.rangeType === "point")
        return ((this.point - this.min) / (this.max - this.min)) * 100 - 0.5;
      else return ((this.slider[0] - this.min) / (this.max - this.min)) * 100;
    }
  }
};
</script>

<style lang="scss">
.distribution-multidiagram {
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 0;
}
</style>
